import {
	type OrderDetailResponseDto,
	OrderFieldTypeEnum,
	type OrderSetupDetailResponseDto,
} from "Infrastructure/Api/Api";

export const getOrderStatusFormData = (order: OrderDetailResponseDto) => {
	return {
		status: order.status,
		dateStarting: order.dateStarting,
		dateDone: order.dateDone,
		cancellationReason: order.cancellationReason,
	};
};

export const getOrderB2BPromoFormData = (order: OrderDetailResponseDto) => {
	return {
		b2b: order.b2b ?? "",
		promoCode: order.promoCode ?? "",
	};
};

export const getOrderGeneralFormData = (order: OrderDetailResponseDto) => {
	return {
		address: order.address ?? "",
		notes: order.notes ?? "",
		marketRegionId: order.region?.id,
	};
};

export const getOrderFieldsFormData = (
	order: OrderDetailResponseDto,
	orderSetup?: OrderSetupDetailResponseDto,
): Array<{ orderFieldId: number; value: string | boolean | number }> => {
	return (
		orderSetup?.orderFields
			.sort((a, b) => a.orderIndex - b.orderIndex)
			.map((field) => {
				let value: string | boolean | number =
					order.fields.find((f) => f.orderField.id === field.id)?.value ?? "";

				if (field.type === OrderFieldTypeEnum.boolean) {
					if (value === "") {
						value = false;
					} else if (value === "true") {
						value = true;
					} else if (value === "false") {
						value = false;
					}
				}

				if (
					field.type === OrderFieldTypeEnum.float ||
					field.type === OrderFieldTypeEnum.integer
				) {
					value = Number.parseFloat(value as string);
					if (Number.isNaN(value)) {
						value = 0;
					}
				}

				return {
					orderFieldId: field.id,
					value,
					key: field.key,
				};
			}) ?? []
	);
};
